import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CategoryCard from './CategoryCard';
import {reqPost,reqGet} from '../../../service';
import { useRecoilState } from 'recoil';
import { ListAtomState,DisplayListAtomState } from '../../../recoil/ModalAtom';

const CategoryBox = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 12px 0 20px;
  scroll-margin-top: 160px;

  /* 모바일: 현재(마지막) 단계만 노출 */
  @media screen and (max-width: 1024px) {
    display: ${p => p.$isCurrent ? 'flex' : 'none'};
  }
`;

const CategoryHeader = styled.div`
  display: flex;
  color: ${p => p.theme.text};
  font-size: 16px;
  font-weight: 700;
  justify-content: flex-start;
  margin: 8px 0 12px;
  gap: 10px;
  align-items: center;
`;

const CategoryInfo = styled.div`
  font-size: 11px;
  color: ${p => p.theme.accent};
  background: ${p => p.theme.accentLight};
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
`;

const TypeBadge = styled.div`
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid ${p => p.$multi ? p.theme.success : p.theme.accent};
  color: ${p => p.$multi ? p.theme.success : p.theme.accent};
  background: ${p => p.theme.bgCard};
`;

const ItemsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
`;

const categoryItemStack = [];
export default function MultiCard(props){
  const [DisplayList, setDisplayList] = useRecoilState(DisplayListAtomState);
    const [ItemStack, setItemStack] = useRecoilState(ListAtomState);
    const [change, setChange]=useState(false);

    useEffect(()=>{
     setChange(!change)
     getCategoryList();
   },[props.categoryCheck]);

    useEffect(()=>{
        getCategoryList();
    },[props.groupChoice]);


    const categoryCheckItem = (e)=>{
        var NewItemStack=[...ItemStack];
        var NewDisplayList = [...DisplayList];
        const itemIndex = categoryItemStack.findIndex(item => item.Key === e.Key);
        const itemNameIndex = categoryItemStack.findIndex(item => item.NAME === e.NAME);
        const itemIndexN = NewItemStack.findIndex(item => item.Key === e.Key);
        const itemNameIndexN = NewItemStack.findIndex(item => item.NAME === e.NAME);

        if((itemIndex !== -1) && (itemNameIndex!== -1) ) {
          var SubValue = props.strTotalValue;
          for (var i=itemIndex; i<categoryItemStack.length;i++) {
            SubValue-=categoryItemStack[i].PRICE;
          }
          props.setStrTotalValue(SubValue);
          categoryItemStack.splice(itemNameIndex);
          NewItemStack.splice(itemNameIndexN);
          if(NewDisplayList[itemNameIndex]===e.Key) {
            NewDisplayList.splice(itemNameIndex+1);
          }
        }
          else if ((itemIndex !== -1) && (itemNameIndex== -1)) {
          var SubValue = props.strTotalValue;
          for (var i=itemIndex; i<categoryItemStack.length;i++) {
            SubValue-=categoryItemStack[i].PRICE;
          }
          props.setStrTotalValue(SubValue+e.PRICE);
          categoryItemStack.splice(itemIndex);
          categoryItemStack.push(e);
          NewItemStack.splice(itemIndexN);
          NewItemStack.push(e);
          if(NewDisplayList[itemIndex]!==e.NEXT) {
            NewDisplayList.splice(itemIndex+1);
          }
          NewDisplayList.push(e.NEXT);
        }
        else {
            categoryItemStack.push(e);
            NewItemStack.push(e);
          props.setStrTotalValue(props.strTotalValue+e.PRICE);
          setItemStack(NewItemStack);
          NewDisplayList.push(e.NEXT);
        }

        setItemStack(NewItemStack);
        props.setSumItemStack(NewItemStack);
        props.setSumItemStack(props.ItemStack.concat(categoryItemStack));
        props.setMultiCategoryCheck(NewDisplayList);
        setDisplayList(NewDisplayList);
        }

   const [CategoryList,setCategoryList] =useState([]);
    const getCategoryList = ()=>{
        reqGet('/api/CategoryList',{group_id:props.Key},(res)=>{
            setCategoryList(res);
        });
    }

    const [SelectedData,setSelectedData]=useState(false);
    const visibleCats = CategoryList.filter((i,index)=>(index===0||props.multiCategoryCheck.includes(i.main_category)||props.categoryCheck.includes(i.main_category)));
    return(<>
        {visibleCats.map((item, idx, arr) => (
        <CategoryBox
            key={idx}
            id={`cat-${item.group_id}-${item.main_category}`}
            $isCurrent={idx === arr.length - 1}
        >
        <CategoryHeader>
        {item.main_category}
        <TypeBadge $multi={item.category_type === 'M'}>
          {item.category_type === 'M' ? '다중 선택' : '단일 선택'}
        </TypeBadge>
        <CategoryInfo>{item.info}</CategoryInfo>
        </CategoryHeader>
        <ItemsContainer>
            <CategoryCard
            group_id={item.group_id}
            Key={item.main_category}
            Type={item.category_type}
            SelectedData = {SelectedData}
            calcValue={(e)=> {
                    setSelectedData(e.NAME);
                    item.category_type == 'M' ? props.calcValue(
                        {
                            GROUP:e.GROUP,
                            Key:e.Key,
                            NAME:e.NAME,
                            PRICE:Number(e.PRICE),
                            DESCRIPTION:e.DESCRIPTION,
                            NEXT:e.NEXT
                        }
                        ): categoryCheckItem({
                            GROUP:e.GROUP,
                            Key:e.Key,
                            NAME:e.NAME,
                            PRICE:Number(e.PRICE),
                            DESCRIPTION:e.DESCRIPTION,
                            NEXT:e.NEXT
                        });
                }}
            CategoryList={CategoryList}
                >
            </CategoryCard>
         </ItemsContainer>
         </CategoryBox>))}
        </>
       );
}
